module.exports = __webpack_public_path__ + "static/media/s12.e53b766a.jpg";